/* ===== BUMP IT — theme.js ===== */

// Cursor
const cursor = document.getElementById('cursor');
if (cursor && window.matchMedia('(pointer: fine)').matches) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });
  document.querySelectorAll('a, button, .product-card, .filter-btn, .variant-btn, .qty-btn, .style-card').forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('expand'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('expand'));
  });
}

// Mobile menu
const burger = document.getElementById('navBurger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger && mobileMenu) {
  burger.addEventListener('click', () => {
    mobileMenu.classList.toggle('open');
    const spans = burger.querySelectorAll('span');
    if (mobileMenu.classList.contains('open')) {
      spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
      spans[1].style.opacity = '0';
      spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
    } else {
      spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
    }
  });
}

// Scroll reveal
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// Nav scroll effect
const nav = document.getElementById('siteNav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.style.background = window.scrollY > 40
      ? 'rgba(10,10,10,0.98)'
      : 'rgba(10,10,10,0.9)';
  }, { passive: true });
}

// Preload all gallery images on page load
document.querySelectorAll('.product-gallery-thumb').forEach(thumb =>{
  const src = thumb.dataset.src;
  if (src) {
    const img = new Image ();
    img.src = src;
    }
    });
// Product gallery thumbnails
document.querySelectorAll('.product-gallery-thumb').forEach((thumb, i) => {
  thumb.addEventListener('click', () => {
    const mainImg = document.querySelector('.product-gallery-main img');
    const src = thumb.dataset.src || querySelector('img').src;
    if (mainImg) {
      mainImg.style.opacity = '0';
      setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 100);
    }
    document.querySelectorAll('.product-gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Variant buttons
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    const group = this.closest('.variant-btns');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
    // Update selected label
    const label = this.closest('.product-option').querySelector('.product-option-label span');
    if (label) label.textContent = this.textContent;
  });
});

// Cart drawer
const cartDrawer = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');
function openCart() {
  if (cartDrawer) cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  if (cartDrawer) cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
}
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));

// Add to cart
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', async function() {
    const form = this.closest('form') || document.getElementById('productForm');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    btn.textContent = 'Aggiungendo...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        // Update cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        btn.textContent = '✓ Aggiunto!';
        setTimeout(() => { btn.textContent = 'Aggiungi al Carrello'; btn.disabled = false; }, 2000);
        openCart();
        refreshCart();
      }
    } catch(e) {
      btn.textContent = 'Errore — Riprova';
      btn.disabled = false;
    }
  });
});

// Refresh cart drawer
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const itemsEl = document.getElementById('cartItems');
    const totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (itemsEl) {
      if (cart.items.length === 0) {
        itemsEl.innerHTML = `<div class="cart-empty"><div class="cart-empty-icon">🛒</div><p>Il tuo carrello è vuoto</p><a href="/collections/all" class="btn btn-outline" style="margin-top:16px">Esplora i Prodotti</a></div>`;
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item-img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
            <div>
              <div class="cart-item-title">${item.product_title}</div>
              <div class="cart-item-variant">${item.variant_title || ''}</div>
              <div class="cart-item-qty">
                <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity - 1})">−</button>
                <span class="qty-num">${item.quantity}</span>
                <button class="qty-btn" onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          </div>
        `).join('');
      }
    }
  } catch(e) {}
}

async function updateQty(key, qty) {
  if (qty < 0) qty = 0;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
  refreshCart();
}

function formatMoney(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

// Product filter
const filterBtns = document.querySelectorAll('[data-filter]');
const productCards = document.querySelectorAll('[data-tags]');
filterBtns.forEach(btn => {
  btn.addEventListener('click', function() {
    filterBtns.forEach(b => b.classList.remove('active'));
    this.classList.add('active');
    const filter = this.dataset.filter;
    productCards.forEach(card => {
      const tags = card.dataset.tags || '';
      if (filter === 'all' || tags.includes(filter)) {
        card.style.display = '';
        setTimeout(() => card.style.opacity = '1', 10);
      } else {
        card.style.opacity = '0';
        setTimeout(() => card.style.display = 'none', 200);
      }
    });
  });
});

// Init cart on load
if (document.getElementById('cartItems')) refreshCart();
